import { createActionCreator, createReducer } from 'deox';
import { ActiveTool, AppState } from 'types/AppState';

export const setActiveTool = createActionCreator('ACTIVE_TOOL/SET', resolve => (tool: ActiveTool) =>
  resolve(tool)
);
export const directLinkToTool = createActionCreator('ACTIVE_TOOL/DIRECT_LINK', resolve => () =>
  resolve()
);
export const activeTool = createReducer(ActiveTool.RatioFormat, handle => [
  handle(setActiveTool, (_, { payload }) => payload)
]);

export const getActiveTool = (state: AppState): ActiveTool => state.activeTool;
